import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { LABEL_ENTITY_VALUE } from '../../../Label'
import {
  getProfileLabelsWidgetItems,
  ProfileLabelsWidget,
} from '../../../Widget'
import { useEmailProfileContext } from '../../Email.hooks'
import { EMAIL_PROFILE_WIDGET_QA_NAME_LABELS } from '../EmailProfileWidget.constants'

import { EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME } from './EmailProfileWidgetLabels.constants'
import {
  getEmailProfileWidgetLabelsInitialValues,
  getEmailProfileWidgetLabelsPayload,
} from './EmailProfileWidgetLabels.utils'

function EmailProfileWidgetLabels({ isSkeleton, widgetProps = EMPTY_OBJECT }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { entityData, handleCloseModal, handleUpdateEntity } =
    useEmailProfileContext()

  const widgetLabels = getProfileLabelsWidgetItems(entityData?.labels)

  async function handleSubmit(payload, successTitle) {
    return handleUpdateEntity(payload, successTitle).catch(() => {
      handleAddErrorNotification('Notification.EmailEditLabelsErrorKey')
    })
  }

  return (
    <ProfileLabelsWidget
      canEdit={entityData?.permissions?.can_edit_labels}
      formProps={{
        entity: LABEL_ENTITY_VALUE.email,
        fieldName: EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME,
        getPayload: getEmailProfileWidgetLabelsPayload,
        initialValues: getEmailProfileWidgetLabelsInitialValues(
          entityData?.labels
        ),
        placeholder: t('EmailProfile.LabelsWidgetPlaceholderKey'),
        onClose: handleCloseModal,
        onSubmit: handleSubmit,
      }}
      isSkeleton={isSkeleton}
      items={widgetLabels}
      listProps={{
        title: t('EmailProfile.LabelsWidgetListTitleKey', {
          count: widgetLabels.length,
        }),
      }}
      title={t('EmailProfile.LabelsWidgetTitleKey')}
      widgetProps={{
        ...widgetProps,
        headerProps: {
          contentProps: {
            actionsProps: {
              addButtonProps: {
                tooltipKey: 'EmailProfile.LabelsWidgetAddButtonTooltipKey',
              },
            },
          },
        },
        qaName: EMAIL_PROFILE_WIDGET_QA_NAME_LABELS,
      }}
    />
  )
}

export default EmailProfileWidgetLabels
